import { pick } from 'lodash';
// https://github.com/substack/utf8-length/
// eslint-disable-next-line no-bitwise
const bytes = (string) => ~-encodeURI(string).split(/%..|./).length;

// they are actually allowing for 200KB but just to be sure
const SENTRY_MAX_ALLOWED_PAYLOAD_BYTE_SIZE = 180000;
export const stateTransformer = (state) => {
  const newState = pick(state, ['questionnaireLogic', 'questionnairePage']);
  const jsonString = JSON.stringify(newState);

  // do not send anything back, in order to be sure that we dont get rejected with 413 errors
  if (bytes(jsonString) > SENTRY_MAX_ALLOWED_PAYLOAD_BYTE_SIZE) {
    return {};
  }

  return newState;
};
